import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
// Configura DevExtreme PRIMA di importare qualsiasi componente
import "./devextreme-config";
import "./index.scss";
import "./utils.scss";
//import "./dexextreme-theme.css";
import "devextreme/dist/css/dx.light.css";

import App from "./App.tsx";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
